<div class="row fields-group">
    <div class="col">
        <label for="transform-field-operator-field"
               class="d-block list-title">{{ 'dataTransformations.fieldOperator' | translate }}</label>
        <select id="transform-field-operator-field" class="d-flex w-100 form-control" [(ngModel)]="fieldOperator"
                (change)="selectChanged()">
            <option *ngFor="let option of selectedOptions" value="{{option.value}}">{{ option.label | translate }}</option>
        </select>
    </div>
</div>
